import Model from "../classes/Model";
import FitnessRoomApi from "../classes/api/FitnessRoom";
import ValidationError from "../classes/ValidationError";

export default class FitnessRoom extends Model {

    get filiationId() {
        return this._filiationId;
    }
    set filiationId(value) {
        this._filiationId = value;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get capacity() {
        return this._capacity;
    }
    set capacity(value) {
        this._capacity = value;
    }
    get content() {
        return this._content;
    }
    set content(value) {
        this._content = value;
    }

    get id() {
        return this._id;
    }

    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }



    toRequest() {
        return {
            id: this.id,
            filiation_id: this.filiationId,
            name: this.name,
            capacity: Number(this.capacity),
            content: this.content,
        };
    }

    static toResponse(data) {
        return {
            id: data.id,
            filiationId: data.filiation_id ? Number(data.filiation_id) : 0,
            name: data.name,
            capacity: data.capacity ? Number(data.capacity) : 0,
            content: data.content,
        };
    }

    static getList(page = 1, perPage = 10, filiationId = false) {
        return FitnessRoomApi.getList(page, perPage, filiationId).then((response) => {
            let data = [];
            for (let room of response.data) {
                data.push(new this(this.toResponse(room)));
            }
            return {data, headers: response.headers};
        });
    }

    static get(id) {
        return FitnessRoomApi.get(id).then(({data}) => {
            let fields = this.toResponse(data);
            fields.id = Number(id);
            return new this(fields);
        });
    }


    add() {
        let request = this.toRequest();
        return FitnessRoomApi.add(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            request.id = Number(data.id);
            return new FitnessRoom(request);
        });
    }

    update() {
        if (!this.id) {
            throw new Error('id not set');
        }
        let request = this.toRequest();
        return FitnessRoomApi.update(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

}